import { useEffect } from "react";
import GlobalHeader from "components/v2/global-header/GlobalHeader";
import useDesktopChecker from "hooks/useDesktopChecker";
import GlobalOuterLayout from "../global-outer-layout/GlobalOuterLayout";
import SideBar from "components/v2/sidebar/SideBar";
import Application from "pages/application/Application";
import { getStepData } from "pages/application/question/questionSlice";
import { useDispatch, useSelector } from "react-redux";
import SectionBar from "components/v2/section-bar/SectionBar";
import { NotificationProvider } from "contexts/NotificationContext";
import { closeProfile, getProfileSettings } from "features/authSlice";
import ProfileSettings from "pages/dashboard/v2/shared/profile-settings/ProfileSettings";
import Footer from "components/footer/Footer";

export const ApplicationSharedLayoutContent = () => {
  const isDesktop = useDesktopChecker();
  const dispatch = useDispatch();
  const { section: activeSection, sections } = useSelector(getStepData);
  const showProfile = useSelector(getProfileSettings);

  useEffect(() => {
    dispatch(closeProfile());
  }, [dispatch]);

  const renderContent = () => {
    if (showProfile) {
      return (
        <div
          className={
            isDesktop
              ? "application-profile-settings-wrapper"
              : "application-profile-settings-mobile"
          }
        >
          <ProfileSettings />
        </div>
      );
    }

    return <Application />;
  };

  return (
    <GlobalOuterLayout>
      {isDesktop && (
        <div className="application-layout-context">
          <SideBar>
            <SectionBar activeSection={activeSection} sections={sections} />
          </SideBar>
          <div className="global-outer-layout__wrapper">
            <GlobalHeader />
            {renderContent()}
            <div className="footer-wrapper">
              <Footer />
            </div>
          </div>
        </div>
      )}
      {!isDesktop && (
        <div className="mobile-container">
          {!showProfile && <GlobalHeader />}
          {renderContent()}
          <Footer />
        </div>
      )}
    </GlobalOuterLayout>
  );
};

export const ApplicationSharedLayout = () => {
  return (
    <NotificationProvider enabled={false}>
      <ApplicationSharedLayoutContent />
    </NotificationProvider>
  );
};

export default ApplicationSharedLayout;
